import { Link } from 'react-router-dom';
import { homeArticles } from '@/mocks/home';

export default function ArticleSection() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">漫资讯</h2>
            <p className="text-sm text-foreground-500 mt-2">漫画圈最新动态与深度解读</p>
          </div>
          <Link
            to="/article/latest"
            className="text-sm text-primary-500 hover:text-primary-600 flex items-center gap-1 whitespace-nowrap cursor-pointer transition-colors"
          >
            全部文章 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {homeArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-all duration-300 group cursor-pointer"
            >
              <div className="aspect-[16/9] overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-xs bg-accent-100 text-accent-700 px-2 py-0.5 rounded whitespace-nowrap">
                    {article.category}
                  </span>
                  <span className="text-xs text-foreground-400">{article.date}</span>
                  <span className="text-xs text-foreground-400">{article.readTime}</span>
                </div>
                <h3 className="text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2 mb-2">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 line-clamp-2 leading-relaxed">
                  {article.excerpt}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}